export default "__VITE_ASSET__iiXdV_4V__"